import { Box, Typography, CircularProgress, Button, Paper } from "@mui/material";
import InputLine from "../ui/inputLine";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";

const Step1Form = ({ formik, loading, error }) => {
    const { values, errors, touched, handleChange, handleBlur } = formik;
    const {t} = useTranslation(PAGE_APPLICATIONS)
    return (
        <Box sx={{ position: "relative", maxWidth: 520, mt: 6 }}>
            <Typography sx={{ mb: 3, color: "#004B88" }}>
                {t("First we need the TIN description")}
            </Typography>

            <InputLine
                label={t("TIN")}
                name="tin"
                required
                value={values.tin}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={9}
                error={touched.tin && errors.tin}
                helperText={errors.tin}
            />

            {error && (
                <Paper
                    elevation={0}
                    sx={{
                        mt: 3,
                        p: 2,
                        borderLeft: "4px solid #C70000",
                        background: "#FFECEC",
                        color: "#C70000",
                        fontSize: 14,
                    }}
                >
                    {error}
                </Paper>
            )}

            {loading && (
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        background: "rgba(255,255,255,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 2,
                    }}
                >
                    <CircularProgress size={40} />
                </Box>
            )}
        </Box>
    );
};

export default Step1Form;
